import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { publicationsApi } from "../services/publications.service";

import {
    PUBLICATIONS_REQUEST,
    publicationsRequestSuccess,
    publicationsRequestFailure,
    publicationsRequest,
    PUBLICATION_UPSERT_REQUEST,
    publicationUpsertRequestFailure,
    publicationUpsertRequestSuccess,
    PUBLICATION_UPSERT_REQUEST_SUCCESS,
    PUBLICATION_UPSERT_REQUEST_FAILURE
} from "../actions/publications.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const publicationsRequestEpic = action$ =>
    action$
        .ofType(PUBLICATIONS_REQUEST)
        .mergeMap((action) =>
            publicationsApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(publicationsRequestSuccess(response.publication, response.focus, response.states, response.publicationTypes, response.people)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(publicationsRequestFailure(error.responseStatus.message))
                )
        );

export const publicationUpsertRequestEpic = action$ =>
    action$
        .ofType(PUBLICATION_UPSERT_REQUEST)
        .mergeMap((action) =>
            publicationsApi
                .upsert(action.publication)
                .mergeMap(response => {
                    return concat$(Observable.of(publicationUpsertRequestSuccess(response.publication)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(publicationUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const publicationUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(PUBLICATION_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => publicationsRequest());

export const publicationUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(PUBLICATION_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow(action.publication.title + " saved"));

export const publicationUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
        action$
            .ofType(PUBLICATION_UPSERT_REQUEST_SUCCESS)
            .map((action: any) => siteDataRequest());

export const publicationUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(PUBLICATION_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/publications.epic.ts